import React, { FC, ReactNode, useContext } from 'react';
import { ContextApi } from 'react-uforms';
import { Col, GridThemeProvider, Row } from 'styled-bootstrap-grid';
import { Question } from '@ch/common/types/data';
import { FormCheckbox } from '@ch/common/components/form/checkbox';
import { Text } from '@ch/common/components/text';
import { customFieldAttr } from './const';
import { QuizContext } from './quiz-context';
import { useAnalyticsData } from './hooks/use-update-analytics-data';

const QuizFieldWrap: FC<Omit<Question, 'children'> & { children: ReactNode }> = ({
  identifier: name,
  customAttributes,
  children,
}) => {
  const { setValue, getValue } = useContext(ContextApi);
  const { intakeId } = useContext(QuizContext);
  const { updateAnalyticsData } = useAnalyticsData();
  const isOptionsExist = customAttributes?.length > 0;
  return (
    <GridThemeProvider gridTheme={{ row: { padding: 5 }, col: { padding: 5 } }}>
      <Row>
        <Col col={12}>{children}</Col>
        {isOptionsExist && (
          <Col col={12}>
            {customAttributes?.map((item, index) => (
              <FormCheckbox
                key={index}
                {...{
                  name: `${customFieldAttr}.${name}.${item.label}`,
                  offValue: false,
                  onValue: true,
                  onChange: () => {
                    updateAnalyticsData({ abandonedField: `checkbox-${name}` }, intakeId);
                    const isChecked = getValue(`${customFieldAttr}.${name}.${item.label}`);
                    setValue(name, isChecked ? item.value : '');
                    const inputField =
                      document.getElementsByName(name) && (document.getElementsByName(name)[0] as HTMLInputElement);
                    inputField.type = isChecked ? 'hidden' : 'text';
                  },
                }}
                $m={[7, 0, 0]}
              >
                <Text $size="md">{item.label}</Text>
              </FormCheckbox>
            ))}
          </Col>
        )}
      </Row>
    </GridThemeProvider>
  );
};

export default QuizFieldWrap;
